module.exports = __webpack_public_path__ + "static/media/sll.static.405c47d2.svg";